module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Breadcrumbs":{"separator":"»"}}}')
  delete Component.options._Ctor
}
